import { createAction, props } from '@ngrx/store';
import { AppStateFailure } from '@symphony-solo/shared/common-state/src';

export enum SyncDataActionTypes {
  SyncronizeAllData = '[SyncData] SyncronizeAllData',
  SyncronizeAllDataSuccess = '[SyncData] SyncronizeAllDataSuccess',
  SyncronizeAllDataError = '[SyncData] SyncronizeAllDataError',
}

export const syncronizeAllDataAction = createAction(SyncDataActionTypes.SyncronizeAllData);
export const syncronizeAllDataSuccessAction = createAction(SyncDataActionTypes.SyncronizeAllDataSuccess);
export const syncronizeAllDataErrorAction = createAction(SyncDataActionTypes.SyncronizeAllDataError, props<{ failure: AppStateFailure }>());
